import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { formatDate } from "../../utils/formateDate";
import { useTranslation } from "react-i18next";
import Skeleton from "react-loading-skeleton";
import { NavLink } from "react-router-dom";
import { OverlayTrigger, Popover } from "react-bootstrap";
import { ConfigProvider, Flex, Radio, Space, Switch } from "antd";
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { getUserDefaultPlan, setUserDefaultPlan } from "../../utils/defaultPlan";

const UserProfileExtra = ({
  profile,
  handleClosePasswordModal,
  handleCloseTransPasswordModal,
  handleCloseRankView,
  moduleStatus,
}) => {
  const options = [
    { label: 'Old Plan', value: 'old' },
    { label: 'New Plan', value: 'new' },
  ];
  const userDefaultPlan = getUserDefaultPlan();

  const [selectedPlan, setSelectedPlan] = useState(profile?.defaultPlan);

  const handlePlanChange = (value) => {
    setSelectedPlan(value);
    setUserDefaultPlan(value);
  }

  const { t } = useTranslation();
  const plan = useSelector(
    (state) => state?.dashboard?.appLayout?.moduleStatus?.mlm_plan
  );
  useEffect(() => {
    if (userDefaultPlan) {
      setSelectedPlan(userDefaultPlan);
    } else if (profile?.defaultPlan) {
      setSelectedPlan(profile?.defaultPlan);
    }
  }, [profile?.defaultPlan, userDefaultPlan]);
  const popover = (carry) =>
  (

    <Popover id="popover">
      <div className="p-1">
        <table className="extra-table">
          <thead>
            <tr>
              <th>Package</th>
              <th>{carry === "left" ? "Left Carry" : "Right Carry"}</th>
            </tr>
          </thead>
          <tbody>
            {profile?.newTreeDetails?.carries?.map((row, index) => (
              <tr key={index}>
                <td>{row.package}</td>
                <td>{carry === "left" ? row.leftCarry : row.rightCarry}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Popover>
  )
  return (
    <div className="col-lg-9 col-md-12 border-prf-left">
      <div className="profDetailuserDtl">
        <div>
          <h5>{t("email")}</h5>
          {profile?.email ? <p>{profile?.email}</p> : <Skeleton width={200} />}
          {/* email verification need check with BE */}
          {moduleStatus?.kyc_status === 1 &&
            (moduleStatus?.kyc_status === 1 ? (
              <p className="text-success">{t("verified")} </p>
            ) : (
              <p className="text-danger">{t("notVerified")} </p>
            ))}
        </div>
        <div>
          <h5>{t("resetPassword")}</h5>
          <p>*************</p>
          <div className="chngPassBtn">
            <button
              type="button"
              className="btn btn-change"
              data-bs-toggle="modal"
              onClick={handleClosePasswordModal}
              style={{ padding: '0px' }}
            >
              {t("resetPassword")}
            </button>
          </div>
        </div>
        <div>
          <h5>{t("resetTransactionPassword")}</h5>
          <p>*************</p>
          <div className="chngPassBtn">
            <button
              type="button"
              className="btn btn-change"
              data-bs-toggle="modal"
              onClick={handleCloseTransPasswordModal}
              style={{ padding: '0px' }}
            >
              {t("resetTransactionPassword")}
            </button>
          </div>
        </div>
        {profile?.userExistInNewPlan && profile?.userExistInOldPlan &&
          <ConfigProvider
            theme={{
              token: {
                colorPrimary: "#954cea", // 👈 your custom primary color
                controlHeight: 38,       // 🔥 increases height of buttons, inputs, radios, etc.
                borderRadius: 8,
              },
            }}
          >

            <Flex vertical gap="middle">
              <Radio.Group
                onChange={(e) => { handlePlanChange(e?.target?.value) }}
                block
                options={options}
                defaultValue={selectedPlan}
                optionType="button"
                buttonStyle="solid"
                value={selectedPlan}
              />
            </Flex>
          </ConfigProvider>
        }
        {!!moduleStatus?.rank_status && (
          <div>
            <h5>{t("current_ranking")}</h5>
            {profile?.rankDetails?.currentRank !== null ? (
              <p>
                {profile?.rankDetails?.currentRank?.name ?? (
                  <Skeleton width={200} />
                )}
                <a
                  href="#"
                  data-bs-toggle="modal"
                  type="button"
                  onClick={handleCloseRankView}
                >
                  <i className="fa-solid fa-eye view_rank_dtl"></i>
                </a>
              </p>
            ) : (
              <p>{t("no_rank_achieved")}</p>
            )}
          </div>
        )}
      </div>
      {profile?.userExistInOldPlan && selectedPlan === "old" &&
        <div className="packageTypesNames new-plan-profile">
          <div className="row">
            <div className="col-md-6">
              <div className="packageNames">
                <div className="sponserType">
                  <h5>{t("plan")}</h5>
                  <p>{"Old Plan"}</p>
                </div>
                <div className="sponserType">

                  <h5>{t("sponsor")}</h5>
                  {profile ? <p>{profile?.sponsor}</p> : <Skeleton width={175} />}
                </div>
                <div className="placementType">
                  <h5>{t("placement")}</h5>
                  {profile?.father ? <p>{profile?.father}</p> : <Skeleton />}
                </div>
                {plan === "Binary" && (
                  <div className="positionType">
                    <h5>{t("position")}</h5>
                    {profile?.position ? (
                      <p>{profile?.position}</p>
                    ) : (
                      <Skeleton />
                    )}
                  </div>
                )}
              </div>
            </div>
            <div className="col-md-6">
              <div className="row">
                {!!moduleStatus?.product_status && (
                  <div className="col-md-6">
                    <div className="PackageDetailProfile">
                      <h5>{t("package")}</h5>
                      {profile?.package?.name ? (
                        <h6>{profile?.package?.name}</h6>
                      ) : (
                        <Skeleton />
                      )}
                      {!!moduleStatus?.package_upgrade && (
                        <NavLink type="button" className="btn"
                          to={{
                            pathname: "/upgrade",
                            search: `?previousPage=${encodeURIComponent("/profile")}`
                          }}>
                          {t("upgrade")}
                        </NavLink>
                      )}
                    </div>
                  </div>
                )}
                {!!moduleStatus?.subscription_status && (
                  <div className="col-md-6">
                    <div className="expiryDetailProfile">
                      <h5>{t("expiry")}</h5>
                      {profile?.productValidity?.productValidityDate ? (
                        <h6>
                          {formatDate(
                            profile?.productValidity?.productValidityDate
                          )}
                        </h6>
                      ) : (
                        <Skeleton />
                      )}
                      <NavLink
                        type="button"
                        className="btn"
                        to={{
                          pathname: "/renew",
                          search: `?previousPage=${encodeURIComponent("/profile")}`
                        }}
                      >
                        {t("renew")}
                      </NavLink>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>}
      {profile?.newTreeDetails && profile?.userExistInNewPlan && selectedPlan === "new" &&
        <>
          <div className="packageTypesNames new-plan-profile mt-2">
            {/* <p>NEW PLAN</p> */}
            <div className="row">
              <div className="col-md-6">
                <div className="packageNames">
                  <div className="sponserType">
                    <h5>{t("plan")}</h5>
                    <p>{"New Plan"}</p>
                  </div>
                  <div className="sponserType">
                    <h5>{t("sponsor")}</h5>
                    {profile ? <p>{profile?.newTreeDetails?.sponsor?.username}</p> : <Skeleton width={175} />}
                  </div>
                  <div className="placementType">
                    <h5>{t("placement")}</h5>
                    {profile?.newTreeDetails?.father ? <p>{profile?.newTreeDetails?.father?.username}</p> : <Skeleton />}
                  </div>
                  {plan === "Binary" && (
                    <div className="positionType">
                      <h5>{t("position")}</h5>
                      {profile?.newTreeDetails?.position ? (
                        <p>{profile?.newTreeDetails?.position}</p>
                      ) : (
                        <Skeleton />
                      )}
                    </div>
                  )}
                </div>
              </div>
              <div className="col-md-6">
                <div className="row">
                  {!!moduleStatus?.product_status && (
                    <div className="col-md-6">
                      <div className="PackageDetailProfile">
                        <h5>{t("package")}</h5>
                        {profile?.newTreeDetails?.package?.name ? (
                          <h6>{profile?.newTreeDetails?.package?.name}</h6>
                        ) : (
                          <Skeleton />
                        )}
                        {!!moduleStatus?.package_upgrade && (
                          <NavLink type="button" className="btn"
                            to={{
                              pathname: "/upgrade",
                              search: `?previousPage=${encodeURIComponent("/profile")}`
                            }}>
                            {t("upgrade")}
                          </NavLink>
                        )}
                      </div>
                    </div>
                  )}
                  {!!moduleStatus?.subscription_status && (
                    <div className="col-md-6">
                      <div className="expiryDetailProfile">
                        <h5>{t("expiry")}</h5>
                        {profile?.productValidity?.productValidityDate ? (
                          <h6>
                            {formatDate(
                              profile?.productValidity?.productValidityDate
                            )}
                          </h6>
                        ) : (
                          <Skeleton />
                        )}
                        <NavLink
                          type="button"
                          className="btn"
                          to={{
                            pathname: "/renew",
                            search: `?previousPage=${encodeURIComponent("/profile")}`
                          }}
                        >
                          {t("renew")}
                        </NavLink>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </>

      }

      <div className="profileStatusSec">
        {profile?.userExistInOldPlan && selectedPlan === "old" && <div className="profileStatusBg">
          <div className="profileStatusContDetailSec">
            <div className="profileStatusIconBg">
              <i className="fa-solid fa-user" style={{ color: "#5e28fb" }}></i>
            </div>
            <div className="statusnameCount">
              <h6>{t("personalPV")}</h6>
              {profile?.pv !== null && profile?.pv !== undefined ? (
                <p>{profile?.pv}</p>
              ) : (
                <Skeleton />
              )}
            </div>
          </div>
          <div className="profileStatusContDetailSec">
            <div className="profileStatusIconBgtwo">
              <i
                className="fa-solid fa-user-group"
                style={{ color: "#7e6711" }}
              ></i>
            </div>
            <div className="statusnameCount">
              <h6>{t("groupPV")}</h6>
              {profile?.gpv !== null && profile?.gpv !== undefined ? (
                <p>{profile?.gpv}</p>
              ) : (
                <Skeleton />
              )}
            </div>
          </div>
          {plan === "Binary" && (
            <>
              <div className="profileStatusContDetailSec">
                <div className="profileStatusIconBgthree">
                  <i
                    className="fa-solid fa-arrow-left"
                    style={{ color: "#2c628a" }}
                  ></i>
                </div>
                <div className="statusnameCount">
                  <h6>{t("leftCarry")}</h6>
                  {profile?.oldCarry?.totalLeftCarry !== null &&
                    profile?.oldCarry?.totalLeftCarry !== undefined ? (
                    <p>{profile?.oldCarry?.totalLeftCarry}</p>
                  ) : (
                    <Skeleton />
                  )}
                </div>
              </div>
              <div className="profileStatusContDetailSec">
                <div className="profileStatusIconBgfour">
                  <i
                    className="fa-solid fa-arrow-right"
                    style={{ color: "#207b70" }}
                  ></i>
                </div>
                <div className="statusnameCount">
                  <h6>{t("rightCarry")}</h6>
                  {profile?.oldCarry?.totalRightCarry !== null &&
                    profile?.oldCarry?.totalRightCarry !== undefined ? (
                    <p>{profile?.oldCarry?.totalRightCarry}</p>
                  ) : (
                    <Skeleton />
                  )}
                </div>
              </div>
            </>
          )}
        </div>}

        {profile?.newTreeDetails && profile?.userExistInNewPlan && selectedPlan === "new" &&
          <div className="profileStatusBg mt-2">
            <div className="profileStatusContDetailSec">
              <div className="profileStatusIconBg">
                <i className="fa-solid fa-user" style={{ color: "#5e28fb" }}></i>
              </div>
              <div className="statusnameCount">
                <h6>{t("personalPV")}</h6>
                {profile?.newTreeDetails?.personalPv !== null && profile?.newTreeDetails?.personalPv !== undefined ? (
                  <p>{profile?.newTreeDetails?.personalPv}</p>
                ) : (
                  <Skeleton />
                )}
              </div>
            </div>
            <div className="profileStatusContDetailSec">
              <div className="profileStatusIconBgtwo">
                <i
                  className="fa-solid fa-user-group"
                  style={{ color: "#7e6711" }}
                ></i>
              </div>
              <div className="statusnameCount">
                <h6>{t("groupPV")}</h6>
                {profile?.newTreeDetails?.groupPv !== null && profile?.newTreeDetails?.groupPv !== undefined ? (
                  <p>{profile?.newTreeDetails?.groupPv}</p>
                ) : (
                  <Skeleton />
                )}
              </div>
            </div>
            {plan === "Binary" && (
              <>
                <div className="profileStatusContDetailSec">
                  <div className="profileStatusIconBgthree">
                    <i
                      className="fa-solid fa-arrow-left"
                      style={{ color: "#2c628a" }}
                    ></i>
                  </div>
                  <div className="statusnameCount">
                    <h6>{t("leftCarry")}</h6>

                    {`${profile?.newTreeDetails?.carries?.length} items `}
                    <OverlayTrigger
                      trigger={["hover", "focus"]}
                      placement="right"
                      overlay={popover("left")}
                    >
                      <i className="fa-solid fa-eye pointer"></i>
                    </OverlayTrigger>
                  </div>
                </div>
                <div className="profileStatusContDetailSec">
                  <div className="profileStatusIconBgfour">
                    <i
                      className="fa-solid fa-arrow-right"
                      style={{ color: "#207b70" }}
                    ></i>
                  </div>
                  <div className="statusnameCount">
                    <h6>{t("rightCarry")}</h6>
                    {`${profile?.newTreeDetails?.carries?.length} items `}
                    <OverlayTrigger
                      trigger={["hover", "focus"]}
                      placement="right"
                      overlay={popover("right")}
                    >
                      <i className="fa-solid fa-eye pointer"></i>
                    </OverlayTrigger>

                  </div>
                </div>
              </>
            )}
          </div>}

      </div>
    </div >
  );
};

export default UserProfileExtra;
